import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/creationMenu/styles.scss';export default {
  "creationMenu": "_creationMenu_49thi_1",
  "button": "_button_49thi_5",
  "icon": "_icon_49thi_25",
  "iconBox": "_iconBox_49thi_33",
  "menu": "_menu_49thi_42",
  "menuItem": "_menuItem_49thi_54",
  "menuText": "_menuText_49thi_67",
  "fileIcon": "_fileIcon_49thi_85",
  "lockIcon": "_lockIcon_49thi_90",
  "block": "_block_49thi_94"
};